import type { NextRouter } from "next/router";
import { isPublicOfferRoutePath } from "screens/browser/routing/publicOfferRoutes";

type RouterWithPush = Pick<NextRouter, "push">;
type QueryValue = string | number | boolean | null | undefined;

type DestinationQuery = Record<string, QueryValue>;

const buildPathWithQuery = (
  pathname: string,
  query: DestinationQuery = {}
): string => {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });

  const queryString = params.toString();
  return queryString ? `${pathname}?${queryString}` : pathname;
};

const navigateWithFullPageLoad = (destination: string): void => {
  if (typeof window === "undefined") {
    return;
  }

  const currentPath = `${window.location.pathname}${window.location.search}`;

  if (currentPath === destination) {
    window.location.reload();
    return;
  }

  window.location.assign(destination);
};

export const navigateAfterAuth = async (
  router: RouterWithPush,
  pathname: string,
  query: DestinationQuery = {}
): Promise<void> => {
  const destination = buildPathWithQuery(pathname, query);

  if (isPublicOfferRoutePath(pathname.split("?")[0])) {
    navigateWithFullPageLoad(destination);
    return;
  }

  await router.push(destination);
};
